export const anthropicApiKeyCookieName = 'anthropicApiKey';
export const anthropicNumFreeUsesCookieName = 'anthropicNumFreeUses';
export const MaxFreeUses = 5;
